export const INSTRUCTION_TITLES = {
  noSaleOrder: "לפי החישוב, אין משמעות לסדר המכירה",
  used49a: "מומלץ להשתמש בסעיף 49(ה) כדי לקבל את המס הנמוך ביותר",
  no49aNeeded: "לפי החישוב, אין צורך להשתמש בסעיף 49(ה)"
};

export function create49aFullExemptionInstruction() {
  return {
    summary: "ניתן למכור את שתי הדירות בפטור מלא, מאחר ששווי המכירה הכולל נמוך מתקרת הפטור המינימלית.",
    steps: []
  };
}

export function createRegularSaleInstruction(firstDealName, secondDealName) {
  return {
    steps: [
      {
        lead: "ראשית",
        dealName: firstDealName,
        route: "במס מוטב"
      },
      {
        lead: "לאחר מכן",
        dealName: secondDealName,
        route: "בפטור דירה יחידה"
      }
    ]
  };
}

export function create49aPartialExemptionInstruction(ptorDealName, linearDealName) {
  return {
    steps: [
      {
        lead: "ראשית",
        dealName: ptorDealName,
        route: "בפטור לפי סעיף 49(ה)"
      },
      {
        lead: "לאחר מכן",
        dealName: linearDealName,
        route: "בלינארי ישן יחסי"
      }
    ]
  };
}
